var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10C0 7.49163 0.996447 5.086 2.77013 3.31231C4.54382 1.53862 6.94946 0.542175 9.45783 0.542175C11.9662 0.542175 14.3718 1.53862 16.1455 3.31231C17.9192 5.086 18.9157 7.49163 18.9157 10C18.9157 12.5084 17.9192 14.914 16.1455 16.6877C14.3718 18.4614 11.9662 19.4578 9.45783 19.4578C6.94946 19.4578 4.54382 18.4614 2.77013 16.6877C0.996447 14.914 0 12.5084 0 10ZM8.9181 14.048L14.3633 7.24084L13.3797 6.45395L8.73651 12.256L5.44771 9.51577L4.64064 10.4842L8.9181 14.048Z",
    fill: "#44D263"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.929fcc2a484f5e927f7fe1dc682e9349.svg";
export { ForwardRef as ReactComponent };